import _ from "lodash";
import { enableEnergyMeter } from "@/common/config";

export function evalGoToLocationMainNav(path, routes, user) {
  try {
    if (
      path === "/maintenance/overview" &&
      !(user.IsAdmin && path !== "/maintenance/tickets") &&
      !evalRequireRoles(
        routes.find(el => el.path === path),
        user.Role_Ids
      )
    ) {
      if (
        evalRequireRoles(
          routes.find(el => el.path === "/maintenance/todo-list"),
          user.Role_Ids
        )
      ) {
        return "/maintenance/todo-list";
      } else {
        return "/maintenance/tickets";
      }
    } else {
      const res = routes.find(el => el.path === path);
      return res.path;
    }
  } catch (e) {
    console.error(e);
  }
}

export function getSideMenu({ sideNavItems, user, router }) {
  // Check allowed roles
  const res = [];
  for (const i in sideNavItems) {
    const searchRouteNav = treeWithChildrenFind(
      { key: "name", val: sideNavItems[i].name },
      router.options.routes
    );
    if (searchRouteNav) {
      if (
        !searchRouteNav.meta.requiredOrganizationType ||
        (Array.isArray(searchRouteNav.meta.requiredOrganizationType) &&
          searchRouteNav.meta.requiredOrganizationType.find(e => e === user.OrganizationType))
      ) {
        const add =
          (user.IsAdmin && !searchRouteNav.meta.forceRequiresRoleOverIsAdmin) ||
          evalRequireRoles(searchRouteNav, user.Role_Ids);
        if (add) {
          res.push(sideNavItems[i]);
        }
      }
    }
  }
  return res;
}

/**
 * Retrieve sidebar page
 * @param {String} name
 * @return {Array}
 */
export function getSidebar(name, router, machineFamily, isFreeTrial, hasSensorIm) {
  let mapSidebar = [];
  const getPath = item => {
    return (
      !!item.meta &&
      item.meta.sidebar === name &&
      item.meta.addPageWithinSidebar === true &&
      (!item.meta.onlyForSensorIm || (item.meta.onlyForSensorIm && hasSensorIm)) &&
      !item.meta?.machineFamilyExcluded?.includes(machineFamily)
    );
  };
  const pathList = router.filter(route => getPath(route));
  mapSidebar = pathList.map(route => {
    return {
      name: route.name,
      sidebarTitle: route.meta?.sidebarTitle || false,
      ico: route.meta.ico || null,
      disabled: (isFreeTrial && !route?.meta?.freeTrialEnabled) || false,
      clearQuery: route?.meta?.clearQuerySideNav || false
    };
  });

  /*
   * Hide page name route sidebar by feature flag
   */

  if (!enableEnergyMeter) {
    mapSidebar = mapSidebar.filter(item => ["machine_energy"].indexOf(item.name) < 0);
  }

  return mapSidebar;
}

/**
 * Retrieve the machine detail pages eligible for free trial
 * @param {String} section the section name
 * @return {Boolean}
 */
export function isSectionAvailableForFreeTrial(section) {
  const availableSectionsForFreeTrial = [
    "machine_production",
    "machine_production2",
    "machine_overview",
    "machine_status",
    "machine_alarms",
    "environmental_sensors"
  ];
  return availableSectionsForFreeTrial.includes(section);
}

/**
 * @param {object} routePage object router options page
 * @param {array} userRoles array of roles object, es. {Id: "AAA",Label: "BBB",Name: CCC"}
 **/
export function evalRequireRoles(routePage, userRoles) {
  let allow = true;
  const { requiresRoles = [] } = routePage.meta;

  if (requiresRoles.length > 0) {
    const found = requiresRoles.findIndex(role => _.some(userRoles, role));
    allow = found !== -1;
  }

  return allow;
}

/*export function checkPageIsInUserNavigation(page, userNavigation) {
  return _.some(userNavigation, function(o) {
    return _.has(o, page);
  });
}*/
/**
 * @param {array} prop objects { key: "", val: ""} to find
 * @param {array} items to evaluate
 **/
export function treeWithChildrenFind(prop, items) {
  let i = 0,
    found;

  for (; i < items.length; i++) {
    if (items[i][prop.key] === prop.val) {
      return items[i];
    } else if (Array.isArray(items[i].children)) {
      found = treeWithChildrenFind(prop, items[i].children);
      if (found) {
        return found;
      }
    }
  }
}
/**
 * @param {array} prop objects { key: "", val: ""} to find
 * @param {array} items to evaluate
 **/
export function treeWithChildrenFindAll(prop, items) {
  let i = 0,
    found,
    result = [];

  for (; i < items.length; i++) {
    if (items[i][prop.key] === prop.val) {
      result.push(items[i]);
    } else if (Array.isArray(items[i].children)) {
      found = treeWithChildrenFindAll(prop, items[i].children);
      if (found.length) {
        result = result.concat(found);
      }
    }
  }

  return result;
}
